import type { ReadyState } from '../../shared/types'
import { Check, Pill } from './ui'

export function ReadyCard({ ready }: { ready: ReadyState }) {
  const remaining = ready.gates.filter((gate) => !gate.done)

  return (
    <section className="card">
      <div className="row-between">
        <h2 className="title">Ready for Tomorrow</h2>
        {ready.ready ? <Pill tone="ok">All done</Pill> : <Pill tone="warn">{remaining.length} to go</Pill>}
      </div>

      <div className="list">
        {ready.gates.map((gate) => (
          <div key={gate.key} className={`check${gate.done ? ' check-done' : ''}`} style={{ cursor: 'default' }}>
            <Check done={gate.done} />
            <span className="check-body">
              <span className="check-title">{gate.label}</span>
              {gate.detail ? <span className="check-detail">{gate.detail}</span> : null}
            </span>
          </div>
        ))}
      </div>

      {ready.ready ? (
        <p className="subtitle">Everything’s done for today. Nothing more is asked.</p>
      ) : (
        <p className="subtitle">Daily responsibilities + one household contribution, checked by a parent.</p>
      )}
    </section>
  )
}
